/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { makeStyles } from '@mui/styles';

export const useRestoreClusterDialogStyles = makeStyles({
  icon: {
    marginTop: '11px',
  },
  tooltipDisabled: {
    color: '#D7CAC4',
  },
});
